import React from 'react'

export default () => (
    <svg fill="currentColor" preserveAspectRatio="xMidYMid meet" width="17" height="17" viewBox="0 0 17 17">
        <g />
        <path d="M3 15h4v-13h-4v13zM4 3h2v11h-2v-11zM10 2v13h4v-13h-4zM13 14h-2v-11h2v11z" />
    </svg>
)
